import { useQuery } from '@tanstack/react-query';
import { CallLog } from '../../components/speedToLead/CallLog';
import { Spinner } from '../../components/ui/Spinner';
import { ApiError } from '../../lib/api';
import { confirmCallOutcome, deleteRecording, fetchClubCalls, fetchLeadHistory, fetchRecordingUrl } from './api';

// ONE CLUB'S CALL LOG (the KyckConnect account tab's Calls sub-tab; it used to sit behind a "Show calls" button on the Speed to
// Lead settings page). Nothing fires on render except the one list read, and that only when the tab is on screen (Radix
// unmounts an inactive tab). Delete exists only for an admin: the host passes isAdmin, the club's portal never does.

function errMessage(err: unknown): string {
  return err instanceof ApiError || err instanceof Error ? err.message : 'Something went wrong.';
}

export function ClubCalls({ clubId, isAdmin }: { clubId: string; isAdmin: boolean }) {
  const query = useQuery({ queryKey: ['speed-to-lead', 'calls', clubId], queryFn: () => fetchClubCalls(clubId), enabled: clubId !== '' });
  return (
    <div data-testid="club-calls" className="space-y-2">
      {query.isLoading && <Spinner />}
      {query.error && <p className="text-sm text-red-600">{errMessage(query.error)}</p>}
      {query.data && (
        <CallLog
          calls={query.data.calls}
          loadPlayUrl={async (kind, id) => (await fetchRecordingUrl(kind, id)).url}
          loadHistory={(kind, id, cursor) => fetchLeadHistory({ call: `${kind}:${id}` }, cursor)}
          onConfirmOutcome={async (kind, id, outcome) => {
            await confirmCallOutcome(kind, id, outcome);
          }}
          onDelete={isAdmin ? async (kind, id) => { await deleteRecording(kind, id); } : undefined}
        />
      )}
    </div>
  );
}
